import { HEADER_HEIGHT } from 'constants/layout'
import React from 'react'
import styled, { css } from 'styled-components'
import PageHeaderImageTeaser from 'uiComponents/atoms/PageHeaderImageTeaser/PageHeaderImageTeaser'
import ScrollDownIcon from 'uiComponents/atoms/ScrollDownIcon/ScrollDownIcon'

const Container = styled.div<{ largeTeaser: boolean }>`
  position: absolute;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  height: 100%;
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.05), 0 2px 4px 0 rgba(0, 0, 0, 0.09);

  ${({ largeTeaser }) =>
    largeTeaser &&
    css`
      height: calc(100% - ${HEADER_HEIGHT}px);
      bottom: 0;
    `};
`

const ButtonContainer = styled.div<{ largeTeaser: boolean }>`
  display: flex;
  position: absolute;
  top: ${({ largeTeaser }) =>
    largeTeaser ? `calc(${HEADER_HEIGHT}px + 30px)` : `30px`};
  left: 60px;
  z-index: 1;
`

const BottomContentContainer = styled.div`
  position: absolute;
  bottom: 0px;
  left: 0;
  right: 0;
  width: 100%;
  display: flex;
  display: column;
  justify-content: center;
`

interface IProps {
  src: string
  fullscreen?: boolean
  navigationElements?: React.ReactNode[]
  targetScrollElementRef?: React.RefObject<HTMLElement | null>
  largeTeaser?: boolean
  disableOverlay?: boolean
  className?: string
  alt?: string
  genderSwitch?: React.ReactNode
}

const HeroTeaser: React.FC<React.PropsWithChildren<IProps>> = props => {
  const {
    src,
    fullscreen = false,
    largeTeaser = false,
    navigationElements,
    children,
    targetScrollElementRef,
    className,
    alt,
    genderSwitch,
    disableOverlay,
  } = props

  return (
    <PageHeaderImageTeaser
      src={src}
      largeTeaser={largeTeaser}
      className={className}
      alt={alt}
      fullscreen={fullscreen}
      disableOverlay={disableOverlay}
    >
      {navigationElements && (
        <ButtonContainer largeTeaser={largeTeaser}>
          {navigationElements.map(element => element)}
        </ButtonContainer>
      )}

      <Container largeTeaser={largeTeaser}>{children}</Container>
      <BottomContentContainer>
        {genderSwitch && genderSwitch}
        {targetScrollElementRef && (
          <ScrollDownIcon targetScrollElementRef={targetScrollElementRef} />
        )}
      </BottomContentContainer>
    </PageHeaderImageTeaser>
  )
}

export default HeroTeaser
